import { defineProductMessages } from './runtime';

export const messages = defineProductMessages({
  "US East (Ohio)": "Leste dos EUA (Ohio)",
  "Google Cloud": "Google Cloud",
  "US East (Northern Virginia)": "Leste dos EUA (norte da Virgínia)",
  "Microsoft Azure": "Microsoft Azure",
  "East US 2 (Virginia)": "Leste dos EUA 2 (Virgínia)",
  "East US (Virginia)": "Leste dos EUA (Virgínia)",
  "No": "Não"
});
